<template>
    <b-modal id="modalItemsExterna" data-backdrop="static" data-keyboard="false" v-model="exibirItens" centered
        :title="this.$t('Confirmar Orçamento')">
        <p>{{ `${$t('Deseja pausar esta OS para aguardar o orçamento?')}` }}</p>
        <v-select :options="getFornecedores" v-model="fornecedores" :placeholder="$t('Fornecedor')"></v-select>

        <div class="mt-3">
            <span for="valores">R$ {{ $t('Valor') }}:</span>
            <input v-model="valor" type="number" class="form-control" id="valores">
        </div>
   
        <div class="mt-3">
            <span for="obsItem">{{ $t('Observação') }}:</span>
            <input v-model="obsOrcamento" type="text" class="form-control" id="obsItem">
        </div>

        <div class="container mt-3 anexoArquivos">
            <h6>{{ $t('Anexo de arquivos') }}:</h6>
            <UploadArquivos></UploadArquivos> 
        </div>

        <template #modal-footer>
            <div class="w-100">
                <div class="row center" style="justify-content: center;">
                    <b-button class="mr-2" variant="danger" size="lg" @click="$emit('fechaModal')">
                        {{ $t('Cancelar') }}
                    </b-button>
                    <b-button size="lg" variant="success" @click="submitValues">
                        {{ $t('Pausar OS') }}
                    </b-button>
                </div>
            </div>
        </template>
    </b-modal>
</template>
<script>
import UploadArquivos from './UploadArquivos.vue';

export default {
    name: "modalOrcamento",
    props: {
        os: {},
        item: {}
    },
    data() {
        return {
            selectServico: "",
            obsOrcamento: "",
            exibirItens: true,
            idConjunto: "",
            valor: "",
            fornecedores: "",
            carregando: false
        };
    },
    components: { UploadArquivos },
    computed: {
        getFornecedores() { 
            const fornecedores = this.$store.getters['filial/fornecedores']

            if (!fornecedores) {
                this.$store.dispatch('filial/getFornecedores')
                return []
            } 

            return fornecedores.map(fornecedor => {
                return {
                    ...fornecedor,
                    label: fornecedor.ds_fornecedor
                }
            })
        },

        filial() {
            return this.$store.getters['filial/filial']
        }
    },

    methods: {
        submitValues() {
            
            const execucao = {
                nr_os: Number(this.$route.params.id),
                obsOrcamento: this.obsOrcamento,
                nr_seq_fornecedor: this.fornecedores.nr_sequencial,
                valor: this.valor,
                tecnico: this.filial?.tecnicoId ?? ''
            }

            const formData = new FormData();
            
            if (document.getElementById('formFiles').value != '') {
                const files = this.$store.state.os.filesUpload
                for (let i = 0; i < files.length; i++) {
                    formData.append('files[]', files[i]);
                }
            }

            formData.append('nr_os', execucao.nr_os)
            formData.append('obsOrcamento', execucao.obsOrcamento)
            formData.append('nr_seq_fornecedor', execucao.nr_seq_fornecedor)
            formData.append('valor', execucao.valor)
            formData.append('tecnico', execucao.tecnico)

            this.$store.dispatch(`os/uploadFilesOrcamento`, { data: formData, nrSeqOs: execucao.nr_os }).then(() => {
                this.$emit('iniciarOrcamento', { data: execucao })
            })
            // }

            // this.$store.dispatch('os/gravaOrdemServicoOrcamento', { data: execucao })


            // this.$store.dispatch('os/getDetails', { nrSequencial: this.$route.params.id }).then(response => {
            //     const execucao = {
            //         nr_os: Number(this.$route.params.id),
            //         obs: this.obsExterna,
            //         adm: false,
            //         nr_seq_fornecedor: this.fornecedores.nr_sequencial
            //     }

            //     const filial = this.$store.getters['filial/filial']

            //     if (filial.atendeOs != "S") {
            //         execucao.adm = true
            //     } 

            //     if (response.data.execucao_inicio) {
            //         this.cod_item = this.item.nr_seq_item

            //         const execucaoParar = {
            //             id: this.item.execucao_final.id,
            //             nr_seq_os_item_update: this.cod_item,
            //             nr_seq_os_item: this.item.nr_sequencial,
            //             nr_seq_os: this.$route.params.id,
            //             nr_seq_clifor: response.data.execucao_inicio.nr_seq_clifor_inicio,
            //             nr_os: this.$route.params.id,
            //             validaExt: false,
            //             obsExterna: this.obsExterna,
            //             osExterna: false,
            //         }

            //         this.$emit('enviaOsExterna', { ...execucao }) 

            //         this.$store.dispatch('osItemExecucao/update', { data: execucaoParar }).then(response => {
            //             this.$store.dispatch('osItem/fetchItemFromApi', { nrSeqOs: this.$route.params.id, nrSequencial: this.item.nr_sequencial })
            //             this.$store.dispatch('osItem/fetchItemFromApiPreventiva', { nrSeqOs: this.$route.params.id, nrSequencial: this.item.nr_sequencial })
            //         })
            //     } else {
            //         this.$emit('enviaOsExterna', { ...execucao })
            //     }
            // })
        },
    },
}
</script>
<style>
    #modalItems {
        pointer-events: none !important;
    }

    .close {
        display: none !important;
    }

</style>